/* ============================================================
   Two Kxngs menu (Oct 2026). Loaded by sections/header.liquid only while "Use the new menu" is ticked.
   Ported from the Empress menu 2026, without the weekly drop card and without tracking.

   Reduced motion: when the phone asks for less motion, the menu opens and closes with no slide.
   (The keyboard stays down when the menu opens because header-sidebar gets initial-focus="[data-tk-nav]",
   so Prestige focuses the menu itself, not the search box. Phones never get an initial focus anyway.)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Reduced motion ---------- */
  function setUpSidebar() {
    var sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || sidebar.dataset.tkStill) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce || !reduce.matches) return;
    /* Only once Prestige has defined the drawer, so its own animation methods exist to wrap */
    if (typeof sidebar.createEnterAnimationControls !== 'function') return;
    sidebar.dataset.tkStill = '1';
    ['createEnterAnimationControls', 'createLeaveAnimationControls'].forEach(function (name) {
      var original = sidebar[name];
      sidebar[name] = function () {
        var controls = original.apply(this, arguments);
        try { controls.finish(); } catch (e) {}
        return controls;
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpSidebar);
  } else {
    setUpSidebar();
  }
  /* The custom element may upgrade after this file runs */
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('header-sidebar').then(setUpSidebar);
  }
  /* The theme editor re-renders the header section when a setting changes */
  document.addEventListener('shopify:section:load', setUpSidebar);
})();
